import { render, staticRenderFns } from "./JobsTable.vue?vue&type=template&id=ed880846"
import script from "./JobsTable.vue?vue&type=script&lang=js"
export * from "./JobsTable.vue?vue&type=script&lang=js"
import style0 from "./JobsTable.vue?vue&type=style&index=0&id=ed880846&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports